import { notification } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import { generateTripLink } from "../../services/userRequestApi";
import { checkPointsDTO } from "../../shared/dtos/checkPointsDTO";
import PassengersDTO from "../../shared/dtos/passengersDTO";
import UserRequestDTO from "../../shared/dtos/userRequestDTO";
import { sortDestinations } from "./sortDestinations";

dayjs.extend(utc);
dayjs.extend(timezone);

export const generateClipboardText = async (
  userRequest: UserRequestDTO,
  distinctPassengers: PassengersDTO[],
  generateForBeta: boolean = false,
) => {
  const passengers =
    distinctPassengers
      ?.map(
        (passenger) =>
          `Nombre: ${passenger.name}\r\nTeléfono: ${passenger.phone}`,
      )
      .join("\r\n") ||
    `Nombre: ${userRequest.user?.firstName} ${userRequest.user?.lastName}\r\nTeléfono: ${userRequest.user?.mobile}`;
  let finalDestinationAddress = userRequest.destinationAddress;
  let destinations;

  if (userRequest.destinations?.length) {
    const userRequestDestinationsToMap = sortDestinations(
      userRequest.destinations,
    );

    finalDestinationAddress =
      userRequestDestinationsToMap[userRequestDestinationsToMap.length - 1]
        .address;

    userRequestDestinationsToMap.pop();

    destinations =
      userRequestDestinationsToMap
        .map(
          (destination: checkPointsDTO, i: number) =>
            `Parada ${i + 1}: ${destination.address}`,
        )
        .join("\r\n") || "";
  }

  let scheduledData = userRequest.scheduleAt;

  if (userRequest.timezone) {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let localDate = dayjs.tz(userRequest.scheduleAt, "DD-MM-YYYY HH:mm", userTimezone);

    if (generateForBeta) {
      localDate = dayjs(userRequest.scheduleAt);
    }

    scheduledData = localDate.utc().tz(userRequest.timezone).format("DD-MM-YYYY | HH:mm");
  }
  else {
    const localDate = dayjs(userRequest.scheduleAt, "DD-MM-YYYY HH:mm");
    scheduledData = localDate.format("DD-MM-YYYY | HH:mm");
  }

  const scheduledDate = userRequest.scheduleAt
    ? `\r\nFecha agendada: *${scheduledData}*`
    : "";

  const serviceType = userRequest.serviceType?.name
    ? `\r\nTipo de servicio: ${userRequest.serviceType.name}`
    : "";

  const driver = userRequest.provider
    ? `\r\nNombre del conductor: ${userRequest.provider.firstName} ${userRequest.provider.lastName}\r\nTeléfono del conductor: ${userRequest.provider.mobile}`
    : "";

  const notes = userRequest.description
    ? `\r\nDetalles: ${userRequest.description}`
    : "";

  const url = userRequest.bookingIdEncrypted
    ? `${process.env.REACT_APP_AIRPORT_QR_CODE_URL}${userRequest.bookingIdEncrypted}`
    : await generateTripLink(userRequest.bookingId!);

  navigator.clipboard.writeText(
    `Booking ID: ${userRequest.bookingId
    }${scheduledDate}${serviceType}\r\nPasajeros:\r\n${passengers}${driver}\r\nOrigen: ${userRequest.originAddress
    }\r\n${destinations ? `${destinations}\r\n` : ""
    }Destino: ${finalDestinationAddress}${notes}\r\nURL del viaje: ${url}`,
  );

  notification.success({
    message: "Informacion del viaje copiada exitosamente!",
    placement: "bottom",
    key: "global",
  });
};
